import { store } from '../redux/configure-store';
import { getNumbersWithDecimal } from './text-formatting-helper';

export const isNumber = (input?: string | number): boolean => {
  if (input === 0) {
    return true;
  }
  return (input ? true : false) && !isNaN(Number(input));
};

export const convertStringToNumber = (input?: string, defaultValue: number = 1): number => {
  if (input === undefined || input.trim() === '' || !isNumber(input)) {
    return defaultValue;
  }
  return Number(input);
};

export const getValueAsNumber = (input?: number | string | boolean): number => {
  const value = Number(input);
  if (isNaN(value)) {
    return 0;
  }
  return value;
};

export const truncateNumberWithPrecision = (
  value: number | string,
  isInput: boolean = true,
): string => {
  const precision = store.getState().touchPoint.touchPointConfiguration
    .defaultWeightUnitOfMeasurePrecision;

  return truncateNumber(value, precision, isInput);
};

export const truncatePrice = (value: number | string, isInput: boolean = true): string => {
  const precision = store.getState().touchPoint.touchPointConfiguration
    .defaultAmountDecimalPrecision;

  return truncateNumber(value, precision, isInput);
};

export const truncateNumber = (
  value: number | string,
  precision: number,
  isInput: boolean = true,
): string => {
  const valString = getNumbersWithDecimal(value.toString());
  const index = valString.indexOf('.');

  return isInput
    ? index >= 0
      ? valString.slice(0, index + precision + 1)
      : valString
    : Number(valString).toFixed(precision);
};
